// src/store/actions/matchesActions.js
import axios from "axios";

export const GET_MATCHES_REQUEST = "GET_MATCHES_REQUEST";
export const GET_MATCHES_SUCCESS = "GET_MATCHES_SUCCESS";
export const GET_MATCHES_FAIL = "GET_MATCHES_FAIL";

export const ADD_MATCH = "ADD_MATCH";
export const UPDATE_MATCH = "UPDATE_MATCH";
export const DELETE_MATCH = "DELETE_MATCH";

const API = process.env.REACT_APP_API_URL;

export const getMatches = (providerId) => async (dispatch) => {
  dispatch({ type: GET_MATCHES_REQUEST });
  try {
    const res = await axios.get(`${API}/matches/get_matches_by_provider/${providerId}`);
    dispatch({ type: GET_MATCHES_SUCCESS, payload: res.data.data || res.data });
  } catch (error) {
    dispatch({ type: GET_MATCHES_FAIL, payload: error.message || error });
  }
};

export const addMatch = (payload) => async (dispatch) => {
  const res = await axios.post(`${API}/matches/add_match`, payload);
  dispatch({ type: ADD_MATCH, payload: res.data.data });
};

export const updateMatch = ({ id, payload }) => async (dispatch) => {
  const res = await axios.put(`${API}/matches/update_match/${id}`, payload);
  dispatch({ type: UPDATE_MATCH, payload: res.data.data });
};

export const deleteMatch = ({ matchId }) => async (dispatch) => {
  const res = await axios.delete(`${API}/matches/delete_match/${matchId}`);
  dispatch({ type: DELETE_MATCH, payload: res.data.data });
};
